<script setup lang="ts">
definePageMeta({ middleware: 'guest' })

const { login } = useAuth()

const form = reactive({ email: '', password: '' })
const busy = ref(false)
const error = ref<string | null>(null)

async function submit(): Promise<void> {
    busy.value = true
    error.value = null

    try {
        await login(form.email, form.password)
        await navigateTo('/home')
    } catch (err: unknown) {
        const fetchError = err as { statusCode?: number; data?: { message?: string } }

        error.value =
            fetchError.statusCode === 422
                ? 'Emel atau kata laluan tidak sah.'
                : (fetchError.data?.message ?? 'Log masuk gagal. Cuba lagi.')
    } finally {
        busy.value = false
    }
}
</script>

<template>
    <div class="mx-auto max-w-md py-8">
        <div class="card !p-6">
            <p class="kicker">Akaun</p>
            <h1 class="mt-1 text-3xl font-bold tracking-tight">Log masuk</h1>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Selamat kembali.</p>

            <form class="mt-6 space-y-4" @submit.prevent="submit">
                <div>
                    <label class="label" for="email">Emel</label>
                    <input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="input"
                        required
                        autocomplete="email"
                    >
                </div>

                <div>
                    <label class="label" for="password">Kata laluan</label>
                    <input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="input"
                        required
                        autocomplete="current-password"
                    >
                </div>

                <p v-if="error" class="notice notice-danger" role="alert">{{ error }}</p>

                <button type="submit" class="btn-primary w-full" :disabled="busy">
                    {{ busy ? 'Sedang log masuk…' : 'Log masuk' }}
                </button>
            </form>

            <div class="mt-5 flex justify-between text-sm font-medium">
                <NuxtLink
                    to="/auth/forgot-password"
                    class="text-brand-600 hover:underline dark:text-brand-400"
                >
                    Lupa kata laluan?
                </NuxtLink>
                <NuxtLink
                    to="/auth/register"
                    class="text-brand-600 hover:underline dark:text-brand-400"
                >
                    Daftar akaun
                </NuxtLink>
            </div>
        </div>
    </div>
</template>
